import { timestampToISOString } from './timestampToString';
export const createWebFsLogsFilename = (timestamp = Date.now()) => createFilename('webfs', timestamp, 'log');
export const createEventTracingJsonFilename = (filesapceData, timestamp = Date.now()) => createFilename(filesapceData.name, timestamp, 'json');
const createFilename = (prefix, timestamp, extention) => `${prefix}.${timestampToISOString(timestamp)}.${extention}`;
